module.exports = __webpack_public_path__ + "img/2.e3df344e.png";